<template>
  <CoverPage :cover="login_background_image">
    <div class="tw:flex tw:flex-col tw:gap-8">
      <img
        class="tw:max-w-[170px] tw:max-h-[80px] tw:object-contain tw:object-left"
        loading="lazy"
        :src="logo || logoVoomp"
        alt="logo"
      />
      <div class="tw:flex tw:flex-col tw:gap-1">
        <TextPlay
          weight="semibold"
          :text="$t('login.header_login')"
          color="var(--fontcolor)"
          size="xl"
        />
        <TextPlay
          size="sm"
          color="var(--text-color)"
          :text="$t('login.header_login_subtitle')"
        />
      </div>
      <Form ref="observer" v-slot="{ errors, values }" class="tw:flex tw:flex-col tw:gap-4">
        <FormFieldPlay
          id="email"
          as="InputPlayV3"
          name="email"
          :label="$t('login.label_email')"
          rules="required|email"
          :placeholder="$t('login.placeholder_email')"
          class="autofill"
          autocomplete="username"
        />

        <FormFieldPlay
          id="password"
          as="InputPlayV3"
          name="password"
          :label="$t('login.label_password')"
          rules="required"
          :type="state.isShowingPass ? 'text' : 'password'"
          :placeholder="$t('login.placeholder_password')"
          class="autofill"
          :right-icon="state.isShowingPass ? 'visibility' : 'visibility_off'"
          right-icon-clickable
          autocomplete="current-password"
          @right-icon-click="toggleShowingPass"
          @enter="captchaButton?.$el?.click()"
        />

        <TextPlay
          v-if="state.error" class="tw:bg-red-100 tw:p-3! tw:text-center" weight="semibold"
          :text="$t('login.error_menssage')" color="var(--feedback-error-500)" />

        <TextPlay
          v-if="accessDenied.status" weight="bold" :text="accessDenied.message"
          color="var(--feedback-error-500)" />

        <CaptchaButton
          ref="captchaButton"
          type="normal"
          :disabled="Object.keys(errors).length > 0 || !values.email || !values.password"
          :text="$t('login.start_session')"
          @click="onSubmit"
        />
        <router-link to="/new-password" class="tw:inline-flex tw:w-fit">
          <TextPlay :text="$t('login.forgot_password')" tag="a" size="sm" color="var(--text-color)" class="tw:underline tw:decoration-current" />
        </router-link>


      </Form>
    </div>
  </CoverPage>
</template>

<script lang="ts" setup>
import { Form } from 'vee-validate';
import { ref, reactive } from 'vue';
import { useAuthStore } from '@/store/auth.store';
import { useStateStore } from '@/store/state.store';
import { computed } from 'vue';
import CoverPage from '@/components/common/CoverPage/CoverPage.vue';
import { FormFieldPlay } from '@/components/atomic';
import logoVoomp from '@/assets/img/logo_voomp.png';
import defaultCover from '@/assets/img/default_cover.png';

const authStore = useAuthStore()
const stateStore = useStateStore()

const observer = ref<InstanceType<typeof Form> & { values?: Record<string, string> } | null>(null)


const logo = computed(() => {
  return stateStore.site?.['logomarca'] || stateStore.site?.['logo']
})

const login_background_image = computed(() => {
  return stateStore.site['login_background_image'] || defaultCover
})

const state = reactive({
  free_courses: false,
  logo: null,
  color: null,
  error: null,
  backgroundImage: null,
  isShowingPass: false,
})

const captchaButton = ref<{ $el: HTMLElement } | null>(null)

const accessDenied = ref({
  status: false,
  message: '',
})


function toggleShowingPass() {
  state.isShowingPass = !state.isShowingPass;
}

async function onSubmit(captcha: string) {
  try {
    const values = observer.value?.values
    authStore.SignInWithPassword({
      email: values?.email || '',
      password: values?.password || '',
      captcha,
    })
  } catch (error) {
    console.error(error);
    state.error = error.message;
  }
}

function _loginWithGoogle() {
  authStore.loginWithGoogle()
}

function _loginWithMicrosoft() {
  authStore.loginWithMicrosoft()
}
</script>
